<template>
  <div class="payment-method-list-item__wrapper">
    <div
      class="payment-method-list-item"
      v-for="(paymentMethod, key) in this.paymentMethods"
      :key="key"
      @click="handleMethodSelection(paymentMethod)"
    >
      <img
        :src="paymentMethodsLabels[paymentMethod].icon"
        :alt="paymentMethodsLabels[paymentMethod].text"
        class="payment-method-list-item__icon"
      />
      <div class="payment-method-list-item__label">
        {{ paymentMethodsLabels[paymentMethod].text }}
      </div>
      <div class="payment-method-list-item__next"><ChevronRightIcon /></div>
    </div>
  </div>
</template>

<script>
import { ChevronRightIcon } from 'vue-feather-icons'
import PaypalIcon from '@/assets/icons/payment/paypal.png'
import CCIcon from '@/assets/icons/payment/card.png'
import CONSTANTS from '@/constants'

const { PAYMENT_METHODS } = CONSTANTS
const { CREDIT_CARD, PAYPAL } = PAYMENT_METHODS

export default {
  name: 'PaymentMethodListItems',
  emits: ['payment-method-selected'],
  components: {
    ChevronRightIcon,
  },
  data() {
    return {
      paymentMethods: PAYMENT_METHODS,
      paymentMethodsLabels: {
        [CREDIT_CARD]: {
          text: 'Credit or debit card',
          icon: CCIcon,
        },
        [PAYPAL]: {
          text: 'PayPal',
          icon: PaypalIcon,
        },
      },
    }
  },
  methods: {
    handleMethodSelection(method) {
      this.$emit('payment-method-selected', method)
    },
  },
}
</script>

<style lang="scss" scoped>
.payment-method-list-item {
  &__wrapper {
    color: var(--white);
    width: 100%;
  }
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border-radius: 10px;
  transition: all 1s ease-out;
  cursor: pointer;
  &:hover {
    background: var(--mid-gray-translucid-gradient);
  }
  &__label {
    font-family: var(--font-regular);
    font-style: normal;
    font-weight: 450;
    width: 100%;
    text-align: left;
    @include desktop {
      font-size: rem(14);
      line-height: 20px;
    }
  }
}
</style>
